import { TextField } from "@mui/material";
import { withStyles } from '@mui/styles';
import { default as React } from "react";
import VMasker from "vanilla-masker";
import { TooltipCustom } from "../infra/styleGlobal";
import * as styleGlobal from "../infra/styleGlobal";
const TextInput = (props) => {
  if (props.tooltip) {
    return <TooltipCustom
      title={props.tooltip} >
      {input2(props)}
    </TooltipCustom>
  } else {
    return input2(props);
  }
}

const input2 = ({ inputForAutocomplete, classes, pure, onChange, title, value, mask, onSubmitEditing, ...others }) => {
  if (pure) {
    return (
      <input
        onChange={(event, value) => {
          if (mask && onChange)
            return onChange(
              VMasker.toPattern(event.target.value, mask)
            );
          if (onChange) onChange(event.target.value);
        }}
        value={value || ""} {...others} />
    )
  } else if (inputForAutocomplete) {
    return (<CssTextField
      label={title}
      className={classes.input}
      variant={"outlined"}
      autoCapitalize={"none"}
      inputProps={{
        form: {
          autoComplete: 'off',
        },
      }}
      margin="normal"
      fullWidth
      value={value || ""}
      onKeyDown={event => {
        if (onSubmitEditing && event.key === "Enter") {
          onSubmitEditing();
        }
      }}
      onChange={onChange}
      {...others}
    />
    )
  } else {
    return (
      <CssTextField
        label={title}
        className={classes.input}
        variant={"outlined"}
        autoCapitalize={"none"}
        inputProps={{
          form: {
            autoComplete: 'off',
          },
        }}
        margin="normal"
        fullWidth
        value={value || ""}
        onChange={(event, value) => {
          if (mask && onChange)
            return onChange(
              VMasker.toPattern(event.target.value, mask)
            );
          if (onChange) onChange(event.target.value);
        }}
        onKeyDown={event => {
          if (onSubmitEditing && event.key === "Enter") {
            onSubmitEditing();
          }
        }}
        {...others}
      />
    );
  }

};

const useStyles = theme => ({
  input: {
    backgroundColor: styleGlobal.color8,
  },
})


const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'black',
    },
    '& .PrivateNotchedOutline': {
      borderStyle: 'none',
    },

    '& .MuiInput-underline': {
      borderBottomColor: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'none',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: styleGlobal.color8,
      },
      '&:hover fieldset': {
        borderColor: styleGlobal.color8,
      },
      '&.Mui-focused fieldset': {
        borderColor: styleGlobal.color8,
      },
      '&.Mui-disabled fieldset': {
        borderColor: styleGlobal.color8,
      },
    },
  },
})(TextField);

export default withStyles(useStyles)(TextInput);

